import { GlobalOutlined } from "@ant-design/icons";
import { Select } from "antd";
import { useTranslation } from "react-i18next";
import { resolveUiLanguage, uiLanguages } from "../i18n/uiLanguages";

/**
 * Switches the interface language.
 *
 * `changeLanguage` is all this has to do: the detector caches the choice in
 * `localStorage`, and `i18n/index.ts` follows the change over to `moment` and
 * `<html lang>`. Every `useTranslation` consumer re-renders on its own.
 */
export const LanguageSwitcher = () => {
    const { i18n, t } = useTranslation();
    const current = resolveUiLanguage(i18n.language);

    return (
        <div className="language-switcher" title={t("language.select")}>
            <Select
                aria-label={t("language.select")}
                className="language-switcher-select"
                size="small"
                bordered={false}
                value={current.code}
                onChange={code => i18n.changeLanguage(code)}
                suffixIcon={<GlobalOutlined />}
                options={uiLanguages.map(language => ({
                    value: language.code,
                    label: language.label
                }))}
            />
        </div>
    );
};
